import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = { class: "summary-card mt-2" }
const _hoisted_2 = { class: "summary-top" }
const _hoisted_3 = { class: "summary-avatar" }
const _hoisted_4 = { class: "summary-avatar-text" }
const _hoisted_5 = { class: "summary-copy" }
const _hoisted_6 = { class: "summary-name-row" }
const _hoisted_7 = { class: "summary-name" }
const _hoisted_8 = {
  key: 0,
  class: "summary-company"
}
const _hoisted_9 = {
  key: 1,
  class: "summary-meta"
}
const _hoisted_10 = { class: "summary-meta-icon" }
const _hoisted_11 = { class: "summary-actions" }
const _hoisted_12 = {
  type: "button",
  class: "summary-action"
}
const _hoisted_13 = {
  type: "button",
  class: "summary-action summary-action--split"
}

import { computed } from "vue";

type Vendor = {
  id: string | number | null;
  name?: string | null;
  vendor_code?: string | null;
  company_name?: string | null;
  phone?: string | null;
  address?: string | null;
};


export default /*@__PURE__*/_defineComponent({
  __name: 'SectionVendorCard',
  props: {
    vendor: {}
  },
  setup(__props: any) {

const props = __props;

const vendorInitials = computed(() => {
  const value = props.vendor?.name || "SU";
  return (
    value
      .trim()
      .split(/\s+/)
      .filter(Boolean)
      .slice(0, 2)
      .map((part) => part[0]?.toUpperCase() || "")
      .join("") || "SU"
  );
});

return (_ctx: any,_cache: any) => {
  const _component_v_icon = _resolveComponent("v-icon")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("span", _hoisted_4, _toDisplayString(vendorInitials.value), 1)
      ]),
      _createElementVNode("div", _hoisted_5, [
        _createElementVNode("div", _hoisted_6, [
          _createElementVNode("p", _hoisted_7, _toDisplayString(__props.vendor?.name || "Vendor"), 1),
          _createVNode(_component_v_icon, {
            size: "16",
            color: "success"
          }, {
            default: _withCtx(() => [...(_cache[0] || (_cache[0] = [
              _createTextVNode("mdi-check-circle-outline", -1)
            ]))]),
            _: 1
          })
        ]),
        (__props.vendor?.company_name)
          ? (_openBlock(), _createElementBlock("p", _hoisted_8, _toDisplayString(__props.vendor?.company_name || "Unknown company"), 1))
          : _createCommentVNode("", true),
        (__props.vendor?.address)
          ? (_openBlock(), _createElementBlock("div", _hoisted_9, [
              _createElementVNode("span", _hoisted_10, [
                _createVNode(_component_v_icon, {
                  size: "14",
                  color: "grey-darken-1"
                }, {
                  default: _withCtx(() => [...(_cache[1] || (_cache[1] = [
                    _createTextVNode("mdi-map-marker-outline", -1)
                  ]))]),
                  _: 1
                })
              ]),
              _createElementVNode("span", null, _toDisplayString(__props.vendor.address), 1)
            ]))
          : _createCommentVNode("", true)
      ])
    ]),
    _createElementVNode("div", _hoisted_11, [
      _createElementVNode("button", _hoisted_12, [
        _createVNode(_component_v_icon, {
          size: "18",
          color: "deep-orange-darken-1"
        }, {
          default: _withCtx(() => [...(_cache[2] || (_cache[2] = [
            _createTextVNode("mdi-message-outline", -1)
          ]))]),
          _: 1
        }),
        _cache[3] || (_cache[3] = _createElementVNode("span", null, "Message", -1))
      ]),
      _createElementVNode("button", _hoisted_13, [
        _createVNode(_component_v_icon, {
          size: "18",
          color: "deep-orange-darken-1"
        }, {
          default: _withCtx(() => [...(_cache[4] || (_cache[4] = [
            _createTextVNode("mdi-phone-outline", -1)
          ]))]),
          _: 1
        }),
        _cache[5] || (_cache[5] = _createElementVNode("span", null, "Call", -1))
      ])
    ])
  ]))
}
}

})